import type { DmStatusTimestamps } from "../app/services/dmThreads";
import type { DmMessage } from "../app/services/dmMessages";

/**
 * status_timestamps の全キーのうち非 null のものの最大日時を返す。
 * これ以前に作成されたメッセージは編集・削除不可のカットオフとして使う。
 *
 * 仕様書 §3-1 で `thread_type` 横断の統一スキーマ（7 キー固定、適用外は `null`）に
 * 正規化されたため、`Object.values` で安全に列挙できる。
 */
export const getDmEditCutoff = (
  st: DmStatusTimestamps | null | undefined,
): Date | null => {
  if (!st) return null;
  const times = Object.values(st)
    .filter((v): v is string => !!v)
    .map((v) => new Date(v).getTime())
    .filter((t) => !Number.isNaN(t));
  return times.length ? new Date(Math.max(...times)) : null;
};

/**
 * DM メッセージが編集・削除可能か判定する。
 * - 自メッセージ（isOurs）かつ `type=user` のみ対象
 * - cutoff が存在する場合、`created_at > cutoff` のメッセージのみ可
 */
export const canEditDmMessage = (
  msg: DmMessage,
  isOurs: boolean,
  cutoff: Date | null,
): boolean => {
  if (!isOurs) return false;
  if (msg.type !== "user") return false;
  if (!cutoff) return true;
  const created = new Date(msg.created_at).getTime();
  if (Number.isNaN(created)) return false;
  return created > cutoff.getTime();
};
